<ng-container *transloco="let t; prefix: 'payment-qr-code'">
  <!-- Create Payment Account modal -->
  <qwiko-modal
    [id]="'payment-qr-code'"
    [isFullScreen]="true"
    [isCentered]="true"
    [isDismissible]="true"
    [enforceHeight]="false"
  >
    <div
      class="z-50 pt-2 pb-2 md:px-2 bg-neutral-100 dark:bg-base-300 border-b border-b-base-200 shadow shadow-neutral-200 dark:shadow-neutral-800"
    >
      <div class="flex md:hidden justify-start items-center mb-2 w-full">
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="modalService.close('payment-qr-code')"
        >
          <span class="flex items-center gap-1">
            <i class="fa-light text-xl fa-arrow-left"></i>
            <span class="text-base mt-1" *transloco="let t">{{
              t("back")
            }}</span>
          </span>
        </button>
      </div>
      <div class="hidden md:flex justify-end items-center mb-2 w-full">
        <button
          type="button"
          class="btn btn-sm btn-ghost rounded-full"
          (click)="modalService.close('payment-qr-code')"
        >
          <span class="flex items-center gap-1">
            <span class="text-sm font-light mt-[0.1rem]" *transloco="let t">{{
              t("close")
            }}</span>
            <i class="fa-light text-base fa-xmark"></i>
          </span>
        </button>
      </div>
      <div class="w-full px-4 py-2 mx-auto">
        <h2 class="text-2xl font-normal text-center w-full mb-2">
          {{ t("qrcode_title") }}
        </h2>
        <h2 class="text-base font-normal text-center w-full mb-2">
          {{ t("qrcode_caption") }}
        </h2>
      </div>
    </div>

    <div
      class="w-full md:w-8/12 mx-auto max-h-[70vh] px-6 md:px-5 pb-10 my-6 overflow-y-auto"
    >
      <qwiko-qr-code [link]="link()" [canDownload]="true"></qwiko-qr-code>
    </div>
  </qwiko-modal>
</ng-container>
